import React from 'react';
import { motion } from 'framer-motion';

const newsData = [
    {
        id: 1,
        title: "Enhancing Customer Experience with AI",
        description: "A retail chain leveraged AI-driven personalization to boost customer engagement and increase sales by 25%.",
        date: "May 07, 2026"
    },
    {
        id: 2,
        title: "Optimizing Supply Chain with cloud ERP",
        description: "Cloud ERP solutions are revolutionizing how businesses manage their supply chains with real-time tracking and insights.",
        date: "May 07, 2026"
    },
    {
        id: 3,
        title: "Modernizing legacy Systems",
        description: "Step-by-step guide on how modernizing your legacy IT systems can drastically reduce operational costs and improve agility.",
        date: "May 07, 2026"
    },
    {
        id: 4,
        title: "Enhancing Customer Experience with AI",
        description: "A retail chain leveraged AI-driven personalization to boost customer engagement and increase sales by 25%.",
        date: "May 07, 2026"
    },
    {
        id: 5,
        title: "Optimizing Supply Chain with cloud ERP",
        description: "Cloud ERP solutions are revolutionizing how businesses manage their supply chains with real-time tracking and insights.",
        date: "May 07, 2026"
    },
    {
        id: 6,
        title: "Modernizing legacy Systems",
        description: "Step-by-step guide on how modernizing your legacy IT systems can drastically reduce operational costs and improve agility.",
        date: "May 07, 2026"
    },
    {
        id: 7,
        title: "Enhancing Customer Experience with AI",
        description: "A retail chain leveraged AI-driven personalization to boost customer engagement and increase sales by 25%.",
        date: "May 07, 2026"
    },
    {
        id: 8,
        title: "Optimizing Supply Chain with cloud ERP",
        description: "Cloud ERP solutions are revolutionizing how businesses manage their supply chains with real-time tracking and insights.",
        date: "May 07, 2026"
    },
    {
        id: 9,
        title: "Modernizing legacy Systems",
        description: "Step-by-step guide on how modernizing your legacy IT systems can drastically reduce operational costs and improve agility.",
        date: "May 07, 2026"
    }
];

const LatestNewsSection = () => {
    const fadeUpVariant = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
    };

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.1 }
        }
    };

    return (
        <section className="w-full py-[40px] md:py-[100px] bg-white font-sora">
            <div className="max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px]">

                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    variants={fadeUpVariant}
                    className="text-center mb-[32px] md:mb-[50px]"
                >
                    <h2 className="text-[20px] md:text-[30px] font-[600] text-[#01386A] tracking-tight">
                        Latest News
                    </h2>
                </motion.div>

                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    variants={fadeUpVariant}
                    className="flex flex-col sm:flex-row justify-between gap-[16px] md:gap-[20px] mb-[32px] md:mb-[40px] max-w-[1000px] mx-auto"
                >
                    <div className="relative w-full sm:w-1/2">
                        <input
                            type="text"
                            placeholder="Search Here...."
                            className="w-full bg-[#F4F5F7] text-[#49577A] lg:text-[16x] text-[14px] font-sora font-[600] rounded-md px-[20px] py-[14px] md:py-[15px] outline-none placeholder:text-[#A0ABC0] focus:ring-1 focus:ring-[#01386A] transition-all"
                        />
                        <svg className="absolute right-[20px] top-[14px] md:top-[15px] text-[#A0ABC0] w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                        </svg>
                    </div>

                    <div className="relative w-full sm:w-1/2">
                        <select className="w-full bg-[#F4F5F7] text-[#49577A] lg:text-[16x] text-[14px] font-sora font-[600] rounded-md px-[20px] py-[14px] md:py-[15px] outline-none appearance-none focus:ring-1 focus:ring-[#01386A] transition-all cursor-pointer">
                            <option>News</option>
                            <option>Articles</option>
                            <option>Events</option>
                        </select>
                        {/* <svg className="absolute right-[20px] top-[16px] md:top-[18px] text-[#A0ABC0] w-5 h-5 pointer-events-none" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                        </svg> */}
                    </div>
                </motion.div>

                <motion.div
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-[16px] md:gap-[30px]"
                >
                    {newsData.map((item) => (
                        <motion.div
                            key={item.id}
                            variants={fadeUpVariant}
                            className="group relative flex flex-col bg-white md:hover:bg-[#01386A] border border-[#E4E8F5] p-[24px] sm:p-[30px] md:p-[40px] h-full min-h-[220px] sm:min-h-[260px] md:min-h-[280px] shadow-sm transition-colors duration-500 overflow-hidden cursor-pointer rounded-sm"
                        >
                            <h3 className="text-[16px] md:text-[20px] font-[600] font-sora text-[#01386A] md:group-hover:text-white transition-colors duration-500 mb-[16px] md:mb-[20px]">
                                {item.title}
                            </h3>

                            <div className="grid grid-rows-[1fr] md:grid-rows-[0fr] transition-[grid-template-rows] duration-500 ease-in-out group-hover:md:grid-rows-[1fr]">
                                <div className="overflow-hidden">
                                    <p className="text-[#49577A] md:text-white/90 text-[14px] font-graphik font-[500] leading-[1.6] pb-[16px] md:pb-[20px] opacity-100 md:opacity-0 transition-opacity duration-500 delay-100 group-hover:md:opacity-100">
                                        {item.description}
                                    </p>
                                </div>
                            </div>

                            <div className="mt-auto flex justify-between items-end w-full relative z-10 pt-[16px] md:pt-[20px]">
                                <a
                                    href="#"
                                    className="inline-flex items-center text-[14px] font-[600] text-[#01386A] md:group-hover:text-white transition-colors duration-300"
                                >
                                    <span className="border-b-[1.5px] border-[#01386A] md:group-hover:border-white pb-[2px] transition-colors duration-300">
                                        Read More
                                    </span>
                                    <span className="ml-2 text-[#F97316] text-[16px] font-bold">&gt;</span>
                                </a>

                                <span className="text-[#F97316] text-[14px] font-[500] font-graphik tracking-wide">
                                    {item.date}
                                </span>
                            </div>

                            <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#01386A] z-20 transition-opacity duration-300 group-hover:opacity-0"></div>

                            <div className="absolute bottom-0 left-0 w-0 h-[4px] bg-[#F97316] transition-all duration-500 ease-out group-hover:w-full z-30"></div>
                        </motion.div>
                    ))}
                </motion.div>

                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={fadeUpVariant}
                    className="flex justify-center mt-[36px] md:mt-[60px]"
                >
                    <a
                        href="#"
                        className="inline-flex items-center text-[14px] lg:text-[16x] font-[600] text-[#01386A] transition-colors duration-300 hover:text-[#F97316] group"
                    >
                        <span className="border-b-[2px] border-[#01386A] group-hover:border-[#F97316] pb-[2px] transition-colors duration-300">
                            Load More
                        </span>
                        <span className="ml-2 text-[#F97316] text-[16px] font-bold">&gt;</span>
                    </a>
                </motion.div>

            </div>
        </section>
    );
};

export default LatestNewsSection;